import type { SelectItem } from '@/components/Atoms/FaceliftSelect/FaceliftSelect.types';
import { colors } from '@/components/ui/theme';

export const STATUS_MAP: Record<number, { label: string; color: string }> = {
  953870010: { label: 'New', color: colors.oceanBlue },
  953870001: { label: 'Appeal Denial And Upheld - Denied', color: colors.deniedRed },
  953870004: { label: 'Appeal Sent', color: colors.statusOrange },
  953870003: { label: 'Approved', color: colors.success },
  953870005: { label: 'Denial Not Appealable', color: colors.deniedRed },
  953870006: { label: 'Denial Overturned - Appeal Success', color: colors.success },
  953870013: { label: 'Guidance Provided to Clinic', color: colors.axolotlBlue },
  953870000: { label: 'Notified Provider', color: colors.statusOrange },
  953870007: { label: 'Pending: Additional Info Needed From Clinic', color: colors.warning },
  953870009: { label: 'Quality Assurance Program', color: colors.nvisionPurple },
  953870002: { label: 'Rejected', color: colors.deniedRed },
  953870008: { label: 'Rejected: Not Denial', color: colors.deniedRed },
  953870011: { label: 'Review Needed', color: colors.warning300 },
  953870012: { label: 'SHORT PAY- template sent', color: colors.statusOrange },
  953870014: { label: 'Pending Details from Clinic', color: colors.warning },
  953870015: { label: 'In Review with Payer', color: colors.lightBlue },
  953870016: { label: 'In Review with TA', color: colors.oceanBlue },
  953870017: { label: 'Guidance Provided to Clinic', color: colors.surfaceGrey },
  953870018: { label: 'Claim Processed Successfully', color: colors.success },
  953870019: { label: 'Denial Support Exhausted (no additional options)', color: colors.deniedRed },
};

export const statusOptions: SelectItem[] = Object.entries(STATUS_MAP).map(
	([value, data]) => ({
		value,
		label: data.label,
	}),
);

export const calculateDaysOpen = (createdon: string): number => {
	if (!createdon) return 0;
	const created = new Date(createdon);
	const now = new Date();
	const diffTime = Math.abs(now.getTime() - created.getTime());
	return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

export const mapStatus = (
	statuscode: number | null | undefined,
): { label: string; color: string } => {
	if (!statuscode) {
		return { label: 'Notified Provider', color: colors.statusOrange };
	}
	return STATUS_MAP[statuscode] || { label: 'Notified Provider', color: colors.statusOrange };
};

export const extractDocumentName = (url: string | null | undefined): string => {
	if (!url) return '---';

	try {
		const cleanUrl = url.endsWith('/') ? url.slice(0, -1) : url;
		const segments = cleanUrl.split('/');
		const lastSegment = segments[segments.length - 1];
		return decodeURIComponent(lastSegment) || '---';
	} catch (error) {
		console.error('Error extracting document name:', error);
		return '---';
	}
};



